import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=57a9d3de&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"
import style0 from "./orders.vue?vue&type=style&index=0&id=57a9d3de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../tmp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a9d3de",
  null
  
)

export default component.exports